import React from 'react';
import { Hero } from '../components/Hero';
import { IngredientsSection } from '../components/IngredientsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { Footer } from '../components/Footer';
import { StickyOrderButton } from '../components/StickyOrderButton';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#4CAF50] selection:text-white pb-20" data-id="element-301">
      <Hero data-id="element-302" />
      <div id="ingredients" data-id="element-303">
        <IngredientsSection data-id="element-304" />
      </div>
      <TestimonialsSection data-id="element-305" />
      <Footer data-id="element-306" />

      {/* Botón sticky que aparece al hacer scroll */}
      <StickyOrderButton data-id="element-307" />
    </div>;
}